<template>
    <div>
        <div class="flex hide-on-print">
            <span class="isolate inline-flex rounded-md shadow-sm">
                <button type="button" class="btn-grp-l" :class="{'active': aggregation == 0}" @click="activateButton(0)">{{$t('shared.auction_filters.filter_periods.months')}}</button>
                <button type="button" class="btn-grp-c" :class="{'active': aggregation == 1}" @click="activateButton(1)">{{$t('shared.auction_filters.filter_periods.weeks')}}</button>
                <button type="button" class="btn-grp-r" :class="{'active': aggregation == 2}" @click="activateButton(2)">{{$t('shared.auction_filters.filter_periods.days')}}</button>
            </span>
            <div v-if="[0,1].indexOf(aggregation) >= 0" class="ml-5 relative" ref="years">
                <select class="inline-block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 leading-tight focus:outline-none focus:shadow-outline"
                        @change="yearChanged"
                        v-model="year">
                    <template v-if="this.auctionYears.length > 0">
                        <option :value="year" v-for="year in auctionYears">{{year}}</option>
                    </template>
                </select>
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                    <icon class="w-4 h-4 inline-block" name="arrow-select"/>
                </div>
            </div>
            <div v-if="aggregation === 2" class="flex my-auto items-center ml-5" ref="days">
                <input class="text-md mr-3" type="date" :max="dateEnd" name="from" v-model="dateStart" ref="dateStartInput" @change="selectedStartMonth"/>
                -
                <input class="text-md mx-3" :min="dateStart" type="date" name="to" v-model="dateEnd" ref="endDateInput" @change="selectedEndMonth"/>
            </div>
        </div>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue2';
import Icon from '@/Shared/Icon';
import {SortDirections} from "@/mixins/SortDirections";
import {ErrorTypes} from "../../mixins/ErrorTypes";

export default {
    mixins: [
        SortDirections,
        ErrorTypes
    ],
    components: {
        Link,
        Icon,
    },
    props: {
        selectedAggregation: Number,
        auctionYears: Array,
        selectedYear: Number,
        states: Object,
        selectedStartDate: String,
        selectedEndDate: String,
    },
    data() {
        return {
            aggregation: this.selectedAggregation || 0, // Aggregation
            year: this.selectedYear > 0 ? this.selectedYear : new Date().getFullYear(),
            dateStart: this.selectedStartDate || '',
            dateEnd: this.selectedEndDate || '',
        }
    },
    methods: {
        activateButton(periodId) {
            this.aggregation = periodId;
            this.$emit('change');
        },
        yearChanged() {
            this.$emit('change');
        },
        selectedStartMonth() {
            if (this.areDatesValid()) {
                this.$emit('change');
            }
        },
        selectedEndMonth() {
            if (this.areDatesValid()) {
                this.$emit('change');
            }
        },
        selectedMonth() {
            this.$emit('change');
        },
        areDatesValid() {
            let sd = new Date(this.dateStart);
            let ed = new Date(this.dateEnd);
            return (sd instanceof Date && isFinite(sd) && sd.getFullYear() >= 2022 ) && (ed instanceof Date && isFinite(ed) && ed.getFullYear() >= 2022 );
        },
        getFilterValues() {
            switch (this.aggregation) {
                case 0:
                case 1:
                    return {
                        aggregation: this.aggregation,
                        year: this.year,
                        valid:true
                    }
                default:
                    let sd = new Date(this.dateStart);
                    let ed = new Date(this.dateEnd);
                    return {
                        aggregation: this.aggregation,
                        year: this.year,
                        dateStart: [sd.getFullYear(), sd.getMonth() + 1, sd.getDate()].join('-'),
                        dateEnd: [ed.getFullYear(), ed.getMonth() + 1, ed.getDate()].join('-'),
                        valid: this.areDatesValid()
                    }
            }
        },
        setFilterValues(newValues) {
            this.aggregation = newValues.aggregation;
            this.year = newValues.year;
            if (2 == this.aggregation) {
                this.dateStart = newValues.dateStart;
                this.dateEnd = newValues.dateEnd;
            }
            this.$emit('change');
        }
    }
}
</script>
